import { Category, QuestionItem } from "../types/form";
import { evaluateVisibility } from "./formVisibility";
import { isEmptyAnswer } from "./answerEmpty";
import { questionInputName } from "./categoryValidation";
import { getValidationRules, hasValidationConstraints } from "./validationRules";
import { validateAnswer } from "./validateAnswer";

export interface CategoryFormatValidationMiss {
  question: QuestionItem;
  inputName: string;
  message: string;
}

function collectCategoryQuestions(category: Category): QuestionItem[] {
  const out: QuestionItem[] = [...(category.questions ?? [])];
  for (const sub of category.subcategories ?? []) {
    out.push(...collectCategoryQuestions(sub));
  }
  return out;
}

/**
 * Find visible questions in this section whose answer fails validationRules
 * (e.g. format: us_ssn). Skips empty answers unless exactEntryCountFrom applies.
 */
export function findFormatErrorsInCategory(
  activeCategory: Category | null,
  formData: Record<string, any>,
  visibleIds?: Set<number>,
): CategoryFormatValidationMiss[] {
  if (!activeCategory) return [];

  const misses: CategoryFormatValidationMiss[] = [];
  for (const question of collectCategoryQuestions(activeCategory)) {
    if ((question.answerType ?? question.type) === "info") continue;
    if (!evaluateVisibility(question, formData, visibleIds)) continue;
    if (!hasValidationConstraints(question)) continue;

    const inputName = questionInputName(question);
    const value = formData[inputName];
    const hasExactCount =
      Number(getValidationRules(question)?.exactEntryCountFrom?.questionId) > 0;
    if (isEmptyAnswer(value) && !hasExactCount) continue;

    const message = validateAnswer(question, value, formData);
    if (!message) continue;

    misses.push({ question, inputName, message });
  }
  return misses;
}
